import { isPast } from 'date-fns/isPast';
import { parseISO } from 'date-fns/parseISO';

import { useDocumentTypeFromPath } from './useUrlGenerator';

export default function useDocumentIsTrailer(document, location = null) {
    const { type = null, trailer = null, video = null, micromag = null, metadata } = document || {};
    const { releaseAt = null } = metadata || {};
    const locationType = useDocumentTypeFromPath(location);
    const finalDocumentType = type || locationType || null;
    const releaseDate = releaseAt !== null ? parseISO(releaseAt) : null;
    const isReleased = releaseDate === null || isPast(releaseDate);
    const videoIsTrailer =
        finalDocumentType === 'video' && trailer !== null && (video === null || !isReleased);
    const micromagIsTrailer =
        finalDocumentType === 'micromag' && trailer !== null && (micromag === null || !isReleased);
    return videoIsTrailer || micromagIsTrailer;
}
